import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCompassSquare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCompassSquare"><Path fillRule="evenodd" clipRule="evenodd" d="M3 21V3H21V21H3ZM9.56698 9.56697L15.4408 8.55917L14.433 14.433L8.5592 15.4408L9.56698 9.56697Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCompassSquare;
